"use strict";

exports.__esModule = true;
exports.BM_EXPERIMENTS = void 0;
const BM_EXPERIMENTS = exports.BM_EXPERIMENTS = {
  MOTO: 'specs.membership.EnableMoto',
  DEALER_BANNERS: 'specs.membership.DealerBanners',
  CUSTOM_FORMS_SHOW_NEW_BADGE: 'specs.membership.CustomFormsShowNewBadge',
  ONBOARDING_CHECKLIST: 'specs.membership.OnboardingChecklist',
  FORCE_ALLOW_CANCELLATION_FOR_UNLIMITED: 'specs.membership.ForceAllowCancelForUnlimited',
  HAS_RECURRING_PAYMENTS_FIX: 'specs.membership.HasRecurringPaymentsFix',
  SETUP_FEE: 'specs.membership.SetupFee',
  DASHBOARD_CONTENT_UPDATES: 'specs.membership.DashboardContentUpdates',
  DUPLICATE_EMAIL_MODAL: 'specs.membership.DuplicateEmailModal',
  REMOVE_PLAN_LIMIT: 'specs.membership.RemovePlanLimit',
  UPDATE_PLAN_CANCELLATION_TOGGLE: 'specs.membership.UpdatePlanCancellationToggle',
  WORKAROUND_BENEFITS_FLICKER: 'specs.membership.WorkaroundBenefitsFlicker',
  CAIRO_TABLE: 'specs.membership.CairoTable',
  ENABLE_FORM_PREVIEW: 'specs.membership.EnableFormPreview',
  ENABLE_FORM_RULES: 'specs.membership.EnableFormRules'
};
//# sourceMappingURL=bm.js.map